import {Component, HostBinding, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {FeatureTypeService} from '@catcore/services';
import {Feature} from '@catcore/services/feature/feature';
import {buildSelectItemsFor} from '@catcore/utils/form-utils';
import {linkedResourceToGenericEmbeddedResource} from '@catcore/utils/json-resources';
import {EvidVidsService} from '@catmodules/models/evid-vids/services/evid-vids.service';
import {EvidVidTypeService} from '@catmodules/models/evid/services/evid-vid-type.service';
import {Evid} from '@catmodules/models/evid/types';
import {FeatureEvidFunction} from '@catmodules/models/feature-evid-functions/types';
import {FeatureEvidVidService} from '@catmodules/models/feature-evid-vid/services/feature-evid-vid.service';
import {EntityForm} from '@catmodules/ui-models/shared/entity-form';
import {SelectItem} from 'primeng/primeng';
import {isNullOrUndefined} from 'util';
import {sortByLabelFunc} from "@catcore/utils";

const componentBaseName = 'feature-evid-vid-form';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-feature-evid-vid-form',
  templateUrl: './feature-evid-vid-form.component.html',
})
export class FeatureEvidVidFormComponent extends EntityForm implements OnInit {
  @HostBinding('class') classNames = defaultClassNames;
  featureEvidFunctionSelectItems: SelectItem[];
  evidSelectItems: SelectItem[];

  displayDelete = false;

  labels = {
    featureEvidFunction: 'Evid Function',
    evid: 'Evid',
    name: 'Name',
    valuesString: 'Values String',
    defaultValue: 'Default Value',
  };

  controlRefs = {
    featureEvidFunction: 'evid_function_type',
    evid: 'evid_type',
    name: 'name',
    valuesString: 'values_string',
    defaultValue: 'default_value',
  };
  private feature: Feature;

  constructor(formBuilder: FormBuilder,
              private router: Router,
              private evidVidService: EvidVidsService,
              private evidTypeService: EvidVidTypeService,
              private featureEvidVidService: FeatureEvidVidService,
              private featureService: FeatureTypeService) {
    super(formBuilder);
  }

  ngOnInit(): void {
    this.featureService
      .getCurrent()
      .subscribe((feature: Feature) => {
        if (!isNullOrUndefined(feature)) {
          this.feature = feature;
          const featureEvidFunctions = this.featureService.extractEvidFunctionsFor(feature);
          this.updateFeatureEvidFunctionSelectItems(featureEvidFunctions);
        }
      });
    this.evidTypeService
      .getAll()
      .subscribe((items: Evid[]) => this.updateEvidSelectItems(items));
  }

  afterDelete() {
    this.featureService.refreshCurrent();
    this.router.navigate(['features', this.feature.id, 'evid-functions']);
  }

  private updateEvidSelectItems(items: Evid[]): void {
    this.evidSelectItems = buildSelectItemsFor(items, 'name', 'name');
    this.evidSelectItems.sort(sortByLabelFunc);
  }

  private updateFeatureEvidFunctionSelectItems(items: FeatureEvidFunction[]): void {
    this.featureEvidFunctionSelectItems = buildSelectItemsFor(items, 'label', 'href');
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/feature-evid-vid/components/feature-evid-vid-form/feature-evid-vid-form.component.ts